import { ReactNode } from 'react';
import styles from './AnouncementPanel.module.css';
import { cx } from '@libs/classnames';
import { AnouncementCheckIcon } from '@features/landing/shared/ui/icons/AnouncementCheckIcon';

type Props = {
  title: ReactNode;
  tags: ReactNode;
  disclaimer?: ReactNode;
  className?: string;
};

export function AnouncementPanel({
  title,
  tags,
  disclaimer,
  className,
}: Props) {
  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.icon}>
        <AnouncementCheckIcon />
      </div>

      <div
        className={cx(styles.content, {
          [styles.hasDisclaimer]: Boolean(disclaimer),
        })}
      >
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.tags}>{tags}</div>
        {disclaimer && <div className={styles.disclaimer}>{disclaimer}</div>}
      </div>
    </div>
  );
}
